import styled from 'styled-components'
import Image from 'common/image'
import TopArrow from 'assets/top-arrow.svg'
import { useTranslation } from 'react-i18next'

const FooterContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 32px 16px;
    justify-content: space-between;
    align-items: flex-start;
    background-color: white;
`

const FirstLineText = styled.div`
    color: #003c84;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const SecondLineText = styled.div`
    padding-top: 16px;
    color: #121b21;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    margin-bottom: 40px;
`

const LinkItemBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const LinkItem = styled.div`
    color: #003c84;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
    padding-right: 12px;
`

const Separator = styled.div`
    width: 1px;
    height: 12px;
    background-color: #000;
    margin-right: 12px;
`

const CopyRightText = styled.div`
    color: #003c84;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
    text-align: center;
`

// const TopArrowContainer = styled.div`
//     cursor: pointer;
//     display: flex;
//     width: 45px;
//     height: 45px;
//     padding: 14px 12px;
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 10px;
//     border-radius: 22.5px;
//     background: #043570;
//     align-self: flex-end;
// `

const FloatButtonContainer = styled.div`
    position: fixed; /* or absolute, depending on desired behavior */
    bottom: 24px;
    right: 4px;
    z-index: 1000; /* Ensure it stays on top */
    -webkit-tap-highlight-color: transparent;
`

const FabButton = styled.div`
    cursor: pointer;
    background-color: #043570;
    color: white;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    /* Add hover effects, etc. */
`

export default function Footer() {
    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }
    const { t } = useTranslation('', { keyPrefix: 'footer' })

    const openLinkInNewTab = (url: string) => {
        window.open(url, '_blank')?.focus()
    }

    const currentYear = new Date().getFullYear()

    return (
        <FooterContainer>
            <FirstLineText>{t('PlayResponsibly')}</FirstLineText>
            <SecondLineText>{t('FootTextMobile')}</SecondLineText>
            <LinkItemBar>
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('ContactUsUrl'))
                    }}
                >
                    {t('ContactUs')}
                </LinkItem>
                <Separator />
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('RulesUrl'))
                    }}
                >
                    {t('Rules')}
                </LinkItem>
                <Separator />
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('ResponsibleGamblingUrl'))
                    }}
                >
                    {t('ResponsibleGambling')}
                </LinkItem>
                <Separator />
            </LinkItemBar>
            <LinkItemBar>
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('PrivacyUrl'))
                    }}
                >
                    {t('Privacy')}
                </LinkItem>
                <Separator />
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('DisclaimerUrl'))
                    }}
                >
                    {t('Disclaimer')}
                </LinkItem>
                <Separator />
                <LinkItem
                    onClick={() => {
                        openLinkInNewTab(t('SecurityTipsUrl'))
                    }}
                >
                    {t('SecurityTips')}
                </LinkItem>
            </LinkItemBar>
            <FloatButtonContainer onClick={scrollToTop}>
                <FabButton>
                    <Image
                        src={TopArrow}
                        width={20.5}
                        height={17}
                        alt="top arrow logo"
                    />
                </FabButton>
            </FloatButtonContainer>
            <CopyRightText>
                {t('Copyright').replace(
                    '{currentyear}',
                    currentYear.toString()
                )}
            </CopyRightText>
        </FooterContainer>
    )
}
